import React, { useCallback, useMemo, useState } from 'react';
import { Button, Input, Col, IconButton, LabeledIconInput } from '@commonsku/styles';
import AddButton from '../misc/AddButton';
import useConfirmDelete from '../hooks/useConfirmDelete';

export default function CompanyCommissionSalesTargetRate({
    item, nextItem, saveItem, deleteItem
}) {
    const [deletePopup, setPopupOpen, setDeleteItem] = useConfirmDelete({ deleteItemCallback: deleteItem });
    const [showForm, setShowForm] = useState(false);
    const defaultValues = useMemo(() => ({
        commission_sales_target_id: '',
        sales_target_min: '',
        multiplier: '',
    }), []);

    const [form, setForm] = useState(item || defaultValues);
    const [formErrors, setFormErrors] = useState(defaultValues);

    const setFormFieldValue = useCallback((e) => {
        const target = e.target;
        setForm((form) => {
            const newValues = { ...form, [target.name]: target.value };
            return newValues;
        });
    }, []);

    const validateForm = useCallback((data) => {
        setFormErrors(defaultValues);
        let errorCount = 0;
        // Check data and set form errors
        for (const field of ['sales_target_min', 'multiplier']) {
            if (data[field].toString().trim() === '') {
                setFormErrors((errors) => ({ ...errors, [field]: 'Required' }));
                errorCount++;
            } else if (field === 'sales_target_min') {
                const min = Number(data[field]);
                if (isNaN(min) || min < 0) {
                    setFormErrors((errors) => ({ ...errors, [field]: 'Minimum must be between 0 and 100' }));
                    errorCount++;
                }
            } else if (field === 'multiplier') {
                const min = Number(data[field]);
                if (isNaN(min) || min < 0) {
                    setFormErrors((errors) => ({ ...errors, [field]: 'Multiplier must be number' }));
                    errorCount++;
                }
            }
        }

        if (errorCount > 0) return false;

        return true;
    }, [defaultValues]);

    const saveForm = useCallback((form) => {
        if (!validateForm(form)) {
            return;
        }
        if (!item) {
            setForm(defaultValues);
            setShowForm(false);
        }
        saveItem({ ...item, ...form });
    }, [defaultValues, item, saveItem, validateForm]);

    const getTextInput = (field, col = 4, hasIcon = false) => {
        const hasError = formErrors[field] !== '';
        const Component = hasIcon ? LabeledIconInput : Input;
        return (
            <Col padded sm={col}>
                <Component
                    style={{ marginBottom: '0' }}
                    iconPosition='right'
                    Icon={<div>%</div>}
                    name={field} value={form[field]}
                    onChange={setFormFieldValue}
                    onBlur={(e) => {
                        if (item) {
                            saveForm(form);
                        }
                    }}
                />
                {hasError ? <span style={{ color: 'red' }}>{formErrors[field]}</span> : ''}
            </Col>
        );
    };

    let formFields = (
        <>
            {getTextInput('sales_target_min', 3, true)}

            <Col padded sm={1} style={{ textAlign: 'center' }}>
                —
            </Col>
            <Col padded sm={3}>
                <LabeledIconInput
                    disabled
                    iconPosition='right'
                    Icon={<div>%</div>}
                    value={item ? nextItem?.['sales_target_min'] || '∞' : ''}
                />
            </Col>

            {getTextInput('multiplier', 3)}

            {!item ?
                (<Col padded sm={1} style={{ textAlign: 'left' }} >
                    <Button size='small' onClick={(e) => saveForm(form)}>{item ? 'Save' : 'Add'}</Button>
                </Col>)
                : null}

            {item ?
                <Col padded sm={1} style={{ textAlign: 'left', paddingLeft: '1rem' }} >
                    <IconButton preset='delete' onClick={() => {
                        setPopupOpen(true);
                        setDeleteItem(item);
                    }} />
                </Col>
                : <Col sm={1}></Col>}
            {deletePopup}
        </>
    );

    if (!item && !showForm) {
        formFields = <Col padded sm={12} style={{ textAlign: 'center' }}>
            <Button className='add-button' onClick={() => { setShowForm(true); }}>
                <AddButton />
            </Button>
        </Col>;
    }

    return formFields;
}
